import React from 'react';

const SenArtisteLogo = ({ className = "w-8 h-8", ...props }) => {
  return (
    <img 
      src="/logo-sen-artiste.png" 
      alt="Sen Artiste" 
      className={className}
      {...props}
    />
  );
};

export default SenArtisteLogo;
